import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { AddSpend } from '../AddSpend'
import s from './EditSpendItemModal.scss'

const EditSpendItemModal = ({
  toggleEditSpendItemtModal,
  isEditSpendItemModalVisible,
  editedItem,
  updateItem,
  changeProperty
}) => {
  return (
    <Modal
      keyboard={false}
      backdrop="static"
      isOpen={isEditSpendItemModalVisible}
      toggle={toggleEditSpendItemtModal}
      size="lg"
    >
      <ModalHeader toggle={toggleEditSpendItemtModal} className={s.modalHeader}>
        Edit Spend Item
      </ModalHeader>
      <ModalBody>
        <AddSpend itemDetails={editedItem} changeProperty={changeProperty} />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleEditSpendItemtModal}>
          Cancel
        </Button>
        <Button className={s.saveBtn} onClick={() => updateItem(editedItem.id)}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default EditSpendItemModal
